<template>
    <div v-if="show" class="error_modal">
        <div class="error_content">
            <h2>Error</h2>
            <p>{{ message }}</p>
            <button class="btn_primary" @click="close">Close</button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['show', 'message'],
    methods: {
        close() {
            this.$emit('close');
        }
    }
}
</script>

<style>
.error_modal {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    justify-items: center;
    z-index: 9999999;
}

.error_content {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    justify-items: center;
    flex-direction: column;
    min-width: fit-content;
    max-width: 95%;
    height: auto;
    background-color: #1a1d24;
    border-radius: 10px;
    color: tomato;
    padding: 20px;
    text-align: center;
    gap: 20px;
}
.error_content p {
    color:#fff;
}
</style>